import { marked, Renderer } from 'marked';

// Custom renderer: preserve original link/bold styling
const renderer = new Renderer();

// Open links in new tab
renderer.link = ({ href, text }) =>
  `<a href="${href}" target="_blank" class="text-blue-600 underline">${text}</a>`;

// Bold text with red color (same as before)
renderer.strong = ({ text }) =>
  `<strong style="color:#dc2626 !important">${text}</strong>`;

marked.use({ renderer });

/**
 * Render a markdown string to HTML block (with <p> wrapping).
 * Supports bold (**text**), links ([text](url)), and multi-line list items.
 */
export function renderBold(text: string): string {
  return marked.parse(text) as string;
}

/**
 * Render a markdown string to inline HTML (without <p> wrapping).
 * Use this when the result needs to stay inline with adjacent elements (e.g. a trailing * symbol).
 */
export function renderBoldInline(text: string): string {
  return marked.parseInline(text) as string;
}
